import { combineReducers } from "redux";
import alert from "./alert";
import auth from "./auth";
import profile from "./profile";
import post from "./post";
// new admin site
import driver from "./admin/driver";
import vehicle from "./admin/vehicle";
import booking from "./admin/booking";
import navtime from "./navtime";
import vehicletype from "./admin/vehicletype";
import setting from "./admin/settings";
import trippackage from "./admin/package";
import airport from "./admin/airport";
import category from "./admin/category";
import template from "./admin/emailtemplate";
import cmspage from "./admin/cmspage";
import cancelreschedule from "./admin/cancelreschedule";
import quotation from "./admin/quotation";
import garage from "./admin/garage";
import referral from "./admin/referral";
import businessuser from "./admin/businessuser";
import individualuser from "./admin/individualuser";
import fleet from "./admin/fleet";
import invoice from "./admin/invoice";

import authBooking from "./authBooking";
import notification from "./notification";
import customerQuotation from "./customerQuotation";

export default combineReducers({
  alert,
  auth,
  profile,
  post,
  driver,
  vehicle,
  booking,
  navtime,
  vehicletype,
  setting,
  trippackage,
  airport,
  category,
  template,
  cmspage,
  authBooking,
  customerQuotation,
  cancelreschedule,
  notification,
  quotation,
  garage,
  referral,
  businessuser,
  individualuser,
  fleet,
  invoice,
});
